import { createFileRoute } from "@tanstack/react-router";
import PrepareDilution from "@/features/inventory/PrepareDilution";

export const Route = createFileRoute("/inventory/prepare/dilution")({
  component: () => (
    <div className="max-w-3xl mx-auto p-4">
      <PrepareDilution />
    </div>
  ),
});
